import script from "./PageShell.vue?vue&type=script&setup=true&lang=js"
export * from "./PageShell.vue?vue&type=script&setup=true&lang=js"

import "./PageShell.vue?vue&type=style&index=0&id=31fbe6e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31fbe6e8"]])

export default __exports__